import Vue from 'vue'

export const AppServiceEventBus = new Vue()

export const AppServiceEventBusType = {
    INFORM: 'INFORM',
    CLOSE_INFORM: 'CLOSE_INFORM',
    TOAST: 'TOAST',
    CONFIRM: 'CONFIRM',
    CONFIRM_DONE: 'CONFIRM_DONE',
    INPUT_TEXT: 'INPUT_TEXT',
    INPUT_TEXT_DONE: 'INPUT_TEXT_DONE',
    TEXT_EDITOR: 'TEXT_EDITOR',
    TEXT_EDITOR_DONE: 'TEXT_EDITOR_DONE'
}
